import CreditorDynamicStepper from '../screens/WalletCreditorForm/dynamicStepper'
import WalletDetailTabs from '../screens/WalletDetailTabs'
import WalletProformaAdminDetails from '../screens/WalletProformaAdminConfirmation'
import WalletProformaDetails from '../screens/WalletProformaDetails'
import WalletProformaInvoiceReceipt from '../screens/WalletProformaInvoiceReceipt'
import WalletTabs from '../screens/WalletTabs'
import DynamicStepper from '../screens/walletForm/dynamicStepper'
import PaymentTermForm from '../screens/walletPaymentTermForm'
import { ROLE, RouteWithAccessType } from './types'

const walletPagesRoleManagement: RouteWithAccessType[] = [
  {
    route: '/adopay/:page',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.PROVIDER_MARKETING,
      ROLE.PROVIDER_IT,
      ROLE.PROVIDER_FINANCE,
      ROLE.PROVIDER_MANAGEMENT,
      ROLE.CHANNEL,
      ROLE.CHANNEL_ACTIVATION,
      ROLE.CHANNEL_ADMIN
    ],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['wallet.view'],
    component: <WalletTabs />,
    tabs: [
      {
        params: { page: 'wallets' },
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.PROVIDER_IT,
          ROLE.PROVIDER_FINANCE,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.CHANNEL,
          ROLE.CHANNEL_ACTIVATION,
          ROLE.CHANNEL_ADMIN
        ],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['wallet.view']
      },
      {
        params: { page: 'payment-terms' },
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['paymentterm.list.view']
      },
      {
        params: { page: 'invoice-list' },
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['proforma.list.view']
      }
    ],
    sections: {
      CHARGE_WALLET: {
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.CHANNEL,
          ROLE.CHANNEL_ACTIVATION,
          ROLE.CHANNEL_ADMIN
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.CHANNEL,
          ROLE.CHANNEL_ACTIVATION,
          ROLE.CHANNEL_ADMIN
        ],
        requiredFeatures: ['wallet.charge']
      },
      MANUAL_SETTLEMENT: {
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.PROVIDER_IT,
          ROLE.PROVIDER_FINANCE,
          ROLE.PROVIDER_MANAGEMENT
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.PROVIDER_IT,
          ROLE.PROVIDER_FINANCE,
          ROLE.PROVIDER_MANAGEMENT
        ],
        requiredFeatures: ['wallet.manual.settlement']
      },
      ADD_CREDITOR: {
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['wallet.creditor.manage']
      },
      EditCreditor: {
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['wallet.creditor.manage']
      }
    }
  },
  {
    route: '/adopay/payment-term/create',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['paymentterm.create'],
    component: <PaymentTermForm />
  },
  {
    route: '/adopay/payment-term/:paymentTermID/details',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['paymentterm.details.view'],
    component: <PaymentTermForm />
  },
  {
    route: '/adopay/wallet/create',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['wallet.create'],
    component: <DynamicStepper />
  },
  {
    route: '/adopay/wallet/:walletId/add-creditors',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['wallet.creditor.manage'],
    component: <CreditorDynamicStepper />
  },
  {
    route:
      '/adopay/wallet/:walletId/(details|settlement|invoice-list|transaction-history)/:status?',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.PROVIDER_MARKETING,
      ROLE.PROVIDER_IT,
      ROLE.PROVIDER_FINANCE,
      ROLE.PROVIDER_MANAGEMENT,
      ROLE.CHANNEL,
      ROLE.CHANNEL_ACTIVATION,
      ROLE.CHANNEL_ADMIN
    ],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['wallet.view'],
    component: <WalletDetailTabs />
  },
  {
    route: '/adopay/wallet/:walletId/invoice-list/:proformaId/details',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['proforma.details.view'],
    component: <WalletProformaDetails />
  },
  {
    route: '/adopay/invoice-list/:proformaId/admin-details',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['proforma.list.view'],
    component: <WalletProformaAdminDetails />
  },
  {
    route: '/adopay/wallet/:walletId/invoice-list/:proformaId/receipt',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['proforma.list.view'],
    component: <WalletProformaInvoiceReceipt />
  }
]

export default walletPagesRoleManagement
